<template>
  <div class="card-ecommend" v-title data-title="卡权益">
    <header>
      <img src="../../assets/images/card-img/card-ecommend-img/icon-24-fanhui.png" alt="" @click="$router.push('/My')"> 
      <p>
        卡权益
      </p>
    </header>
    <section>
      <!-- 卡片 -->
      <div class="card-show">
        <div>
          <img :src="card_msg.thumbnil" alt="">
          <p v-if="card_msg.ismember == true">{{card_msg.card_no}}</p>
        </div>
      </div>
      <!-- 卡权益 -->
      <div class="card-quanyi">
        <!-- 标题 -->
        <p class="card-quanyi-title">
          <img src="../../assets/images/card-img/card-ecommend-img/4.png" alt="" class="img1">
          {{card_msg.name}}专属权益
          <span @click="shareBtn">
            <img src="../../assets/images/card-img/card-ecommend-img/2.png" alt="">
            分享
          </span> 
        </p>
        <p class="flash-sales">
          <img src="../../assets/images/card-img/card-ecommend-img/1.png" alt="">
          {{card_msg.callboard}}
        </p>
        <div class="card-recommend" v-html="card_msg.detail">

        </div>
      </div>
    </section>
    <footer>
      <div class="card-payment">
        <span>限时特惠</span>
        <span>{{card_msg.pcate}}</span>
        <!-- <span>元{{card_msg.validity/12}}年</span> -->
        <span>元</span>
        <span @click="payCardBtn(card_msg.id)" v-if="card_msg.ismember == false">立即抢购</span>
        <span @click="ture_member" v-else>已是会员</span>
      </div>
    </footer>
  </div>
</template>
<script>

import Vue from 'vue';
import { Toast, Dialog} from 'vant';
import wx from 'weixin-js-sdk'

Vue.use(Toast)

export default {
  data(){
    return{
      card_msg: [], // 卡权益
      card_id: ''
    }
  },

  created(){
    this.url = window.location.href
    this.card_id  = this.$route.query.id
    // console.log(this.card_id)
    // 登录 / 分享登录
    let uid = JSON.parse(localStorage.getItem("uid"));
    // alert(uid)
    if(!uid){
      let wxcode = this.$route.query.code
      // 获取code
      if(!wxcode){
        //appid 可以从后端传过来 也可以写死 
        let APPID = this.domain.APPID
        // 跳转回调redirect_uri 可以从后端传过来 也可以写死 但是url必须是公网可访问的
        let REDIRECT_URI = encodeURIComponent(window.location.href)
        // 返回类型
        let code = 'code';
        // 应用授权作用域，snsapi_base （不弹出授权页面，直接跳转，只能获取用户openid），snsapi_userinfo （弹出授权页面，可通过openid拿到昵称、性别、所在地。并且， 即使在未关注的情况下，只要用户授权，也能获取其信息 ）
        let SCOPE = 'snsapi_userinfo';
        let STATE = '123';//随便写
        let url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + APPID + '&redirect_uri=' + REDIRECT_URI + '&response_type=' + code + '&scope=' + SCOPE + '&state=' + STATE + '#wechat_redirect';
        window.location.href = url;
        // console.log(url)
        // console.log(encodeURIComponent(this.domain.local_url))
      }else{
        window.localStorage.removeItem('uid');
        // 传code
        let mypid = this.$route.query.pid
        if(!mypid){
          mypid = 0
        }
        this.$axios.get(this.domain.url+"/api/user/public/login",{
        params:{
          pid : mypid,
          code : wxcode,
          url : this.domain.local_url
        },
        }).then((res) => {
          // console.log(res.data.data.uid)
          window.localStorage.setItem('uid',JSON.stringify(res.data.data.uid));
        })
      }
    }else{
      this.$axios.get(this.domain.url+"/api/home/index/islogin").then((res) => {
        // console.log(res)
        if(res.data.code == 0){
          window.localStorage.removeItem('uid');
          this.$router.go(0)
        }
      })
    }

    // 查询卡权益 
    this.$axios.get(this.domain.url+'/api/card/index/detail?id=' + this.card_id).then((res) =>{
      this.card_msg = res.data.data
      // console.log(this.card_msg)

    })

    // 调用微信自带分享
    let usrId = JSON.parse(localStorage.getItem("uid"));
    this.ShareImpl({
      shareTitle: 'KFM康养卡',
      shareDesc: '【限时特惠】截止4月30号之前，仅需99元可享本卡十年使用权',
      shareUrl: this.url + '&pid=' + usrId,
      shareImg: 'http://api.kfm666666.net/upload/default/20200325/adc9c0a6b2668b473901d315e3b845ef.jpg',
    });
    // console.log(usrId)
  },
  mounted(){
  },
  methods:{
    // 分享
    shareBtn(){
      let usrId = JSON.parse(localStorage.getItem("uid"));
      window.location.href = "http://api.kfm666666.net/api/pay/index/wxshare?title=" + this.card_msg.name + '&desc=' + this.card_msg.callboard + '&imgurl=' + this.card_msg.thumbnil + '&pid=' + usrId + '&link=' + this.url
      // let testUrl = "http://api.kfm666666.net/api/pay/index/wxshare?title=" + this.card_msg.name + '&desc=' + this.card_msg.callboard + '&imgurl=' + this.card_msg.thumbnil + '&link=' + this.url+ '?pid=' + usrId
      // console.log(testUrl)
    },
    // 会员提示
    ture_member(){
      Toast('您已是会员！')
    },
    // 跳转购买页
    payCardBtn(id){
      // console.log(id)
      this.$router.push({
        path:'/buy-card',
        query: {
          id : id
        }
      })
      // this.$axios.get(this.domain.url+"/api/user/public/integrality").then((res) => {
        // console.log(res)
        // if(res.data.code == 0){
        //   Dialog.confirm({
        //     title: '请完善信息后再购买',
        //     // message: '弹窗内容'
        //   }).then(() => {
        //     this.$router.push('/perfect')
        //   }).catch(() => {
        //     // on cancel
        //   });
        // }else{
        // }
      // })
    },

    // 微信自带分享
    ShareImpl(option) {
      //option是分享的配置内容*/
      let aaa = window.location.href
      let usrId = JSON.parse(localStorage.getItem("uid"));
      this.$axios.get('http://members.kfm666666.net/api/share/index/wxshare?link=http://members.kfm666666.net/').then((response) => {
          // console.log(response)
          wx.config({
              debug: false,
              appId: response.data.data.shareConfig.appId,
              timestamp: response.data.data.shareConfig.timestamp,
              nonceStr: response.data.data.shareConfig.nonceStr,
              signature: response.data.data.shareConfig.signature,
              jsApiList: [
                // 'updateAppMessageShareData',
                // 'updateTimelineShareData',
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
              ]
          });
      }).catch(error => {
          window.console.log(error);
      });
      wx.ready(function () {
        // wx.updateAppMessageShareData({
        //     title: option.shareTitle,
        //     desc: option.shareDesc,
        //     link: option.shareUrl,
        //     imgUrl: option.shareImg,
        //     success:function(res){
        //       console.location(res)
        //     }
        // });
        // wx.updateTimelineShareData({
        //     title: option.shareTitle,
        //     desc: option.shareDesc,
        //     link: option.shareUrl,
        //     imgUrl: option.shareImg,
        //     success:function(res){
        //       console.location(res)
        //     }
        // });
        wx.onMenuShareTimeline({
            title: option.shareTitle,
            desc: option.shareDesc,
            link: option.shareUrl,
            imgUrl: option.shareImg,
            success:function(res){
              console.location(res)
            }
        });
        wx.onMenuShareAppMessage({
            title: option.shareTitle,
            desc: option.shareDesc,
            link: option.shareUrl,
            imgUrl: option.shareImg,
            success:function(res){
              console.location(res)
            }
        });
      })
      /*}*/
    }
  }
}
</script>
<style lang="less" scoped>
  .card-ecommend{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    header{
      width: 100%;
      height: .88rem;
      display: flex;
      align-items: center;
      img{
        width: .18rem;
        height: .35rem;
        margin-left: .33rem;
      }
      p{
        width: 6.54rem;
        font-family: PingFang-SC-Bold;
        color: #333333;
        font-size: 0.36rem;
        text-align: center;
      }
    }
    section{
      width: 100%;
      flex: 1;
      overflow: scroll;
      // 卡片展示
      .card-show{
        width: 100%;
        height: 5.16rem;
        overflow: hidden;
        div{
          width: 6.9rem;
          height: 4.43rem;
          margin: 0 auto;
          margin-top: .23rem;
          position: relative;
          img{
            width: 6.9rem;
            height: 4.43rem;
          }
          p{
            position: absolute;
            right: .32rem;
            bottom: .4rem;
            font-size: .21rem;
            font-family:Adobe Heiti Std;
            font-weight:normal;
            color:rgba(54,55,55,1);
            text-shadow: 0rem 0rem 0rem rgba(81,49,27,0.57);
          }
        }

      }
      // 卡权益
      .card-quanyi{
        // 卡权益标题
        .card-quanyi-title{
          width: 100%;
          font-size: 0.3rem;
          font-family: PingFang SC;
          font-weight: bold;
          color: #080808;
          font-size: 0.32rem;
          .img1{
            width: .31rem;
            height: .33rem;
            margin-right: .2rem;
            margin-left: .5rem;
          }
          span{
            float: right;
            font-size: 0.24rem;
            font-family: PingFang SC;
            font-weight: 500;
            color: #332C24;
            margin-right: .49rem;
            display: flex;
            align-items: center;
            img{
              width: .3rem;
              height: .33rem;
              margin-right: .1rem;
            }
          }
        }
        // 限时特惠
        .flash-sales{
          width: 6.85rem;
          height: .59rem;
          margin: 0 auto;
          font-size: 0.24rem;
          font-family: PingFang SC;
          font-weight: 500;
          color: #332C24;
          margin-top: .3rem;
          display: flex;
          align-items: center;
          background: #fef8ec;
          margin-bottom: .2rem;
          img{
            width: .44rem;
            height: .44rem;
            margin-right: .52rem;
            margin-left: .1rem;
          }
        }
        // 卡介绍
        .card-recommend{
          // width: 100%;
          font-family: PingFang-SC-Regular;
          color: #666666;
          font-size: 0.24rem;
          // display: flex;
          // flex-direction: column;
          // overflow: scroll;
          margin-left: .3rem;
          margin-right: .32rem;
          // p{
          //   margin: .16rem .32rem .16rem .3rem;
          //   line-height: .36rem;
          // }
        }
      }
    }
    footer{
      // 抢购
      .card-payment{
        width: 7rem;
        height: .78rem;
        // display: flex;
        // align-items: center;
        background-image: url(../../assets/images/card-img/card-ecommend-img/3.png);
        background-size: 7rem .78rem;
        margin: 0 auto;
        line-height: .78rem;
        span{
          &:first-child{
            font-size: 0.3rem;
            font-family: PingFang-SC-Bold;
            font-weight: bold;
            color: #FFFFFF;
            margin-left: .8rem;
          }
          &:nth-child(2){
            font-size: 0.36rem;
            font-family: PingFang-SC-Bold;
            font-weight: bold;
            color: #FFFFFF;
            margin-left: .1rem;
            margin-right: .1rem;
          }
          &:nth-child(3){
            font-size: 0.24rem;
            font-family: PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
          }
          &:last-child{
            font-size: 0.3rem;
            font-family: PingFang SC;
            font-weight: bold;
            color: #563F06;
            float: right;
            margin-right: .7rem;
          }
        }
      }
    }
  }
</style>